import React from "react";

const StudioBreakSection = () => {
  return (
    <section className="py-12 relative overflow-hidden">
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: 'linear-gradient(rgba(0,0,0,0.15), rgba(0,0,0,0.15)), url("https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/pbn48qh3_image.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat'
        }}
      />
      
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Behind the Scenes at Kitco Mining
          </h3>
          <p className="text-lg text-gray-200 leading-relaxed">
            From our state-of-the-art studio, we deliver exclusive interviews and breaking news 
            that shapes the global mining industry conversation.
          </p>
        </div>
      </div>
    </section>
  );
};

export default StudioBreakSection;